/* eslint-disable max-len */
import { TableBody, TableHead, TableRow, Icon } from "@mui/material";
import {
  useMemo,
  useState,
  useContext,
  useRef,
  createRef,
  useEffect,
} from "react";
import { useScreenClass } from "react-grid-system";
import { useNavigate, useParams } from "react-router-dom";
import styled from "styled-components";
import { UserContext } from "../../context/UserContext";
import theme from "../../styles/theme";
import FlexBox, { FlexGrow } from "../../components/FlexBox";
import { ClickableIcon } from "../../components/Icon";
import TableComponent, {
  StyledBodyCell,
  StyledHeaderCell,
  StyledTableRow,
} from "../../components/Table";
import {
  EmptyPillarNavigation,
  EmptyPillarTypeDetail,
  PillarNavigationType,
  PillarTypeDetail,
} from "../../types/Roadmap";
import PillarSubdomainModify from "../../components/PillarSubdomainModify";
import Button from "../../components/Button";
import axios from "axios";
import { CustomFlex } from "./ModifyPillarDetail";
import PillarNavigator from "../../components/PillarNavigator";
import PillarSubdomainCreate from "../../components/PillarSubdomainCreate";
import LoadingSpinner from "../../components/LoadingSpinner";
import SnackBar from "../../components/SnackBar";
import ConfirmModal from "../../components/ConfirmModal";
import { VersionContext } from "../../context/VersionContext";
import { SaveButton } from "../../components/PillarOverviewModify";
interface Column {
  id: "title" | "description" | "action";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

function PillarSubdomains() {
  const ref = useRef(null);
  const { pillarId } = useParams();
  const navigate = useNavigate();
  const [isCreateOpen, setIsCreateOpen] = useState<boolean>(false);
  const [pillarDetail, setPillarDetail] = useState<PillarTypeDetail>(
    EmptyPillarTypeDetail
  );
  const [pillarNavigation, setPillarNavigation] =
    useState<PillarNavigationType>(EmptyPillarNavigation);
  const [loading, setLoading] = useState<boolean>(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [isConfirmOpen, setIsConfirmOpen] = useState<boolean>(false);
  const [currentPillar, setCurrentPillar] = useState<PillarTypeDetail>();
  const { version } = useContext(VersionContext);
  const [subdomain, setSubdomain] = useState<Array<any>>([]);
  const [columns, setColumns] = useState<Array<Column>>([
    { id: "title", label: "Subdomain Title", minWidth: 200 },
    {
      id: "description",
      label: "Description",
      minWidth: 150,
    },
    {
      id: "action",
      label: "",
      minWidth: 50,
    },
  ]);
  useEffect(() => {
    if (pillarId) {
      // fetchPillar(pillarId)
      fetchSubdomain(pillarId);
    }
  }, []);

  const fetchSubdomain = (pillar_id: string) => {
    setLoading(true);
    axios
      .get(`/subdomain/summary?pillar_id=${pillarId}&curriculum_version=${version.version_number}`)
      .then((res) => {
        axios
        .get(`/pillar?curriculum_version=${version.version_number}`)
        .then((res1) => {
            setSubdomain(res.data.subdomains);
            setPillarNavigation({
              ...pillarNavigation,
              id: pillar_id,
              title: res1.data.pillars.find((v: any) => v.id === pillar_id)
                .title,
            });
            {
              setLoading(false);
            }
          })
          .catch(() => {
            setLoading(false);
          });
      })
      .catch(() => {
        axios
        .get(`/pillar?curriculum_version=${version.version_number}`)
        .then((res1) => {
            setSubdomain([]);

            setPillarNavigation({
              ...pillarNavigation,
              id: pillar_id,
              title: res1.data.pillars.find((v: any) => v.id === pillar_id)
                .title,
            });
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      });
  };

  const createSubdomain = (data: any) => {
    setLoading(true);
    axios
      .post("/subdomain/new", { ...data, pillar_id: pillarId })
      .then((res) => {
        setMessage("Created subdomain successfully");
        setIsSnackbarOpen(true);
        setLoading(false);
        setIsCreateOpen(false);
        fetchSubdomain(pillarId || "");
        // fetchPillar(pillarId || '')
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to create subdomain!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
        setLoading(false);
      });
  };
  const deleteSubdomain = () => {
    axios
      .delete(
        `/subdomain/delete?subdomain_id=${currentPillar?.id}&curriculum_version=${version.version_number}`
      )
      .then((res) => {
        setMessage("Subdomain deleted successfully!");
        setIsSnackbarOpen(true);
        setLoading(false);
        // fetchPillar(pillarId || '')
        fetchSubdomain(pillarId || "");
        setIsConfirmOpen(false);
      })
      .catch(function (error) {
        if (error.response) {
          setMessage(
            error.response.data.error || "Failed to delete subdomain!"
          );
          setIsErrorOpen(true);
        } else if (error.request) {
          console.log(error.request);
        } else {
          setMessage(error.response.data.error);
          setIsErrorOpen(true);
        }
      });
  };
  return (
    <>
      {isCreateOpen && (
        <PillarSubdomainCreate
          header="Create Subdomain"
          mode="create"
          isOpen={isCreateOpen}
          setOpen={setIsCreateOpen}
          onSaveComplete={(data) => {
            createSubdomain(data);
          }}
        />
      )}
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={message}
        type="error"
      />
      <ConfirmModal
        isOpen={isConfirmOpen}
        setOpen={setIsConfirmOpen}
        confirmFunction={() => {
          deleteSubdomain();
        }}
        title={"Delete Subdomain"}
        description={"Are you sure you want to delete this subdomain?"}
      />
      {loading && <LoadingSpinner />}
      <CustomFlex
        style={{
          minHeight: "inherit",
          height: "100%",
          borderBottom: "none",
          alignItems: "flex-start",
          overflowY: "scroll",
          padding: 0,
        }}
      >
        <FlexGrow
          className="visible-scrollbar"
          style={{
            overflowX: "auto",
            maxHeight: "calc(100vh - 70px)",
            minHeight: "calc(100vh - 70px)",
          }}
        >
          <CustomFlex>
            <FlexGrow>
              <PillarNavigator path={pillarNavigation} />
            </FlexGrow>
          </CustomFlex>
          <TableComponent navHeight="170px" aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => {
                  if (column.id === "action") {
                    return (
                      <StyledHeaderCell
                        key={column.id}
                        align={column.align}
                        backgroundColor={theme.color.lightBlueGray50}
                        color={theme.color.lightBlueGray800}
                        style={{
                          minWidth: column.minWidth,
                          maxWidth: "102px",
                          textAlign: "end",
                        }}
                      >
                        <SaveButton
                          className="reduce_opct_onhover"
                          onClick={() => setIsCreateOpen(true)}
                          style={{
                            width: "auto",
                            color: "white",
                          }}
                        >
                          <Icon fontSize="small" style={{ paddingRight: 5 }}>
                            add_circle_outline_icon
                          </Icon>
                          Create Subdomain
                        </SaveButton>
                      </StyledHeaderCell>
                    );
                  }
                  return (
                    <StyledHeaderCell
                      key={column.id}
                      align={column.align}
                      backgroundColor={theme.color.lightBlueGray50}
                      color={theme.color.lightBlueGray800}
                      style={{ minWidth: column.minWidth }}
                    >
                      {column.label}
                    </StyledHeaderCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {subdomain?.map((row: any, index) => {
                return (
                  <StyledTableRow
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    onDoubleClick={() =>
                      navigate(`/modify/pillar/${pillarId}/subdomain/${row.id}`)
                    }
                    // onClick={() => {
                    //   onSelect(row);
                    // }}
                    key={index}
                  >
                    {columns.map((column) => {
                      if (column.id === "action") {
                        return (
                          <StyledBodyCell
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                            }}
                            style={{
                              verticalAlign: "middle",
                              textAlign: "end",
                              paddingRight: "30px",
                            }}
                            key={column.id}
                            align={"right"}
                          >
                            <span className="reduce_opct_onhover">
                              <ClickableIcon
                                style={{ textShadow: "0 2px 4px #8080807a" }}
                                onClick={() =>
                                  navigate(
                                    `/modify/pillar/${pillarId}/subdomain/${row.id}`
                                  )
                                }
                                fixedWidth={false}
                                size={3}
                                name={"edit"}
                              />
                            </span>
                            <span className="reduce_opct_onhover">
                              <ClickableIcon
                                // className="reduce_opct_onhover"
                                onClick={() => {
                                  setCurrentPillar(row);
                                  setIsConfirmOpen(true);
                                }}
                                style={{
                                  color: "red",
                                  textShadow: "0 2px 4px #8080807a",
                                  marginLeft: "10px",
                                  // border: "0.5px solid",
                                  // background: "#b21818",
                                  // borderRadius: "30%",
                                }}
                                fixedWidth={false}
                                size={3}
                                name={"delete"}
                              />
                            </span>
                          </StyledBodyCell>
                        );
                      }
                      const value = row[column.id];
                      return (
                        <StyledBodyCell key={column.id} align={column.align}>
                          {column.format && typeof value === "number"
                            ? column.format(value)
                            : value}
                        </StyledBodyCell>
                      );
                    })}
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </TableComponent>
        </FlexGrow>
      </CustomFlex>
    </>
  );
}
export default PillarSubdomains;
